import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { listDirectBookingsImage } from 'config/imageUrls';

import { ContentSection, StyledBulletList } from './styles';

export const HowWeAreDifferent = () => {
  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12} md={7}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h2">How Are We Different?</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  The core features and benefits of what alluraDirect provides for vacation rental by owner properties,
                  are similar to what other hosting options like VRBO and airBNB provide. Marketing, secure online
                  payments, guest communication, reservation management, dispute mediation and other expected services
                  are included, <strong>but how are we different?</strong>
                </Typography>

                <StyledBulletList>
                  <li>25+ years in business. alluraDirect has been promoting ski vacation rentals since 1997.</li>
                  <li>Experts in ski resort and mountain destination marketing for vacation properties.</li>
                  <li>Our guest list is full of repeat, experienced and respectful destination travelers.</li>
                  <li>Lower guest service fees than most other global hosting platforms. *</li>
                </StyledBulletList>
                <div>
                  <i>
                    <small>
                      * In some cases, guests can save over 50% on the total service fee when booking on alluraDirect
                      instead of the competiting websites - great for repeat guests.
                    </small>
                  </i>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={5} align="center">
            <img
              src={listDirectBookingsImage}
              className="add-image-shadow"
              width="100%"
              style={{ maxWidth: '485px' }}
            />
          </Grid>
        </Grid>
      </ContentSection>
    </>
  );
};
